const CONFIG_SAVED = 'config_saved';
export const CONFIG_VALUES_UPDATED = 'config_values_updated';

export default CONFIG_SAVED;
